<template>
  <div>
  <div class="welcome-container">
    <!-- Welcome Message OUTSIDE the Card -->
    <div class="top-welcome">
      👋 Hello, <span class="username">{{ firstName }}</span>!
    </div>

    <!-- Card -->
    <div class="welcome-card">
      <div class="card-body">
        <!-- Highlighted System Title -->
        <h2 class="system-title">
          Welcome to <span class="brand">My Tuition Wave</span>
        </h2>
        <p class="system-desc">
          Discover our powerful tuition management system that makes learning simple, effective, and engaging. 
          Let’s make your journey smoother with <span class="highlight">Mysoftcode’s innovation</span>.
        </p>

        <!-- Tuition Wave Logo -->
        <div class="logo-box">
          <img src="@/assets/TuitionWave.png" alt="Tuition Wave Logo" />
        </div>
      </div>

      <!-- Footer -->
      <div class="powered-by">
        <span>Powered by </span><span class="brand">Mysoftcode</span>
      </div>
    </div>

    
  </div>
  <div>
      <FooterView/>
  </div>
  </div>
</template>

<script>
import FooterView from './FooterView.vue';
export default {
  data() {
    return {
      firstName: ''
    };
  },
  components:{
      FooterView,
    },
  mounted() {
    const firstName = localStorage.getItem('firstName');
    if (firstName) this.firstName = firstName;
  }
};
</script>

<style scoped>
/* Page Background */
.welcome-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 100vh;
  padding: 2rem 1rem;
  background: linear-gradient(135deg, #f700ff, #00ffff);
}

/* Top Welcome Message */
.top-welcome {
  padding-top:2.5dvh ;
  font-size: 1.8rem;
  font-weight: 600;
  color: #fff;
  margin-bottom: 1.5rem;
  text-align: center;
  animation: fadeInDown 1s ease;
}
.top-welcome .username {
  color: #ffdd57;
  text-shadow: 0 0 8px rgba(255, 221, 87, 0.8);
}

/* Card Styling */
.welcome-card {
  width: 100%;
  max-width: 550px;
  background: #ffffff;
  border-radius: 1rem;
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  animation: fadeIn 1s ease-in-out;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

/* Card Body */
.card-body {
  padding: 2rem;
  text-align: center;
  background: linear-gradient(145deg, #f9f9f9, #ffffff);
}

/* System Title */
.system-title {
  font-size: 2rem;
  font-weight: bold;
  color: #333;
  margin-bottom: 1rem;
}
.system-title .brand {
  color: #007bff;
  text-shadow: 0 0 8px rgba(0, 123, 255, 0.5);
}

/* System Description */
.system-desc {
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 2rem;
}
.system-desc .highlight {
  color: #28a745;
  font-weight: bold;
}

/* Tuition Wave Logo */
.logo-box {
  width: 140px;
  height: auto;
  margin: 0 auto 1.5rem auto;
}
.logo-box img {
  width: 100%;
  height: auto;
  object-fit: contain;
}

/* Powered By */
.powered-by {
  text-align: center;
  padding: 1rem;
  background: #f9f9f9;
  border-top: 1px solid #eee;
  font-size: 0.9rem;
  color: #666;
}
.powered-by .brand {
  color: #007bff;
  font-weight: bold;
  display: inline-block;
  animation: flicker 2s infinite;
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; transform: translateY(20px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes fadeInDown {
  from { opacity: 0; transform: translateY(-20px); }
  to { opacity: 1; transform: translateY(0); }
}
@keyframes flicker {
  0% { opacity: 1; text-shadow: 0 0 5px #00f, 0 0 10px #0ff; }
  20% { opacity: 0.8; text-shadow: 0 0 10px #0ff, 0 0 20px #00f; }
  40% { opacity: 1; text-shadow: 0 0 15px #0ff, 0 0 25px #007bff; }
  60% { opacity: 0.9; text-shadow: 0 0 8px #007bff, 0 0 15px #0ff; }
  80% { opacity: 1; text-shadow: 0 0 12px #0ff, 0 0 22px #00f; }
  100% { opacity: 1; text-shadow: 0 0 5px #007bff, 0 0 10px #0ff; }
}

/* Responsive */
@media (max-width: 576px) {
  .top-welcome {
    font-size: 1.4rem;
  }
  .system-title {
    font-size: 1.6rem;
  }
  .system-desc {
    font-size: 1rem;
  }
  .logo-box {
    width: 100px;
  }
}
</style>
